import Constrain from "./Constrain";

import { pluralize } from "utils/text";

class MaxProducts extends Constrain {
  static Name = "MAX_PRODUCTS";

  getName(): string {
    return MaxProducts.Name;
  }

  getErrorMessage(productsCount: number): string {
    if (this.errorMessage) {
      return this.errorMessage;
    }
    if (productsCount === this.getValue()) {
      return `You've got already ${pluralize(
        productsCount,
        "item",
      )} on this box or some of the transactions are still pending. If you don't have a confirmed transaction, wait 3 minutes to buy another item.`;
    }

    return `You've already bought ${pluralize(
      productsCount,
      "item",
    )} from this box, you can buy only ${
      this.getValue() - productsCount < 0 ? 0 : this.getValue() - productsCount
    } more. If the transaction is still pending, please wait 3 minutes to buy up to ${this.getValue()} items.`;
  }

  getMaxValue(): number {
    return this.value;
  }
}

export default MaxProducts;
